import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Select } from '@ngxs/store';
import { IModuleUserDateRangeFilters } from 'app/library/module-user/interfaces/module-user-date-range-filters.interface';
import { ModuleUser } from 'app/library/module-user/models/module-user.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { ModuleParticipantsState } from '../../models/module-participants.state';
import { ModuleParticipantsService } from '../../services/module-participants.service';

export class ModuleParticipantsDataSource implements DataSource<ModuleUser> {
    @Select(ModuleParticipantsState.getFiltersList)
    filter$: Observable<ModuleUser>;

    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    constructor(private _filteredUser$: Observable<ModuleUser[]>, private _moduleParticipantsService: ModuleParticipantsService) {}

    connect(collectionViewer: CollectionViewer): Observable<ModuleUser[]> {
        return this._filteredUser$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
        // Intentionally do not complete `_loadingSubject`.
        // The mat-table is destroyed when switching to the empty state (e.g. after removing
        // the last participant), which can happen while a load is still in flight.
        // Completing the subject would leave `isLoading` stuck at true.
    }

    async loadUsers(
        moduleId: string,
        search?: string,
        sortBy?: string,
        sortOrder?: string,
        pageSize?: number,
        pageNumber?: number,
        withoutCertificate?: boolean,
        selectedCertificateIds?: string[],
        selectedProgressStatuses?: string[],
        dateRangeFilters?: IModuleUserDateRangeFilters
    ): Promise<void> {
        this._loadingSubject.next(true);

        try {
            await this._moduleParticipantsService.fetchModuleParticipants(
                moduleId,
                search,
                sortBy,
                sortOrder,
                pageSize,
                pageNumber,
                withoutCertificate,
                selectedCertificateIds,
                selectedProgressStatuses,
                dateRangeFilters
            );
        } finally {
            this._loadingSubject.next(false);
        }
    }
}
